import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { isUndefined } from 'lodash';
import CampaignModal from '../components/Modal';
import useQueryString from '../../hooks/useQueryString';

export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNeverShow, setIsNeverShow] = useState(false);
  const currentMoment = moment().utcOffset(8);
  const firstStartMoment = moment().utcOffset(8).set({ year: 2023, month: 4, date: 8 }).startOf('day');
  const firstEndMoment = moment().utcOffset(8).set({ year: 2023, month: 4, date: 12 }).endOf('day');
  const secondStartMoment = moment().utcOffset(8).set({ year: 2023, month: 4, date: 15 }).startOf('day');
  const secondEndMoment = moment().utcOffset(8).set({ year: 2023, month: 4, date: 19 }).endOf('day');
  const { disablePop } = useQueryString();

  const onCheckboxChange = (_event, checked) => {
    setIsNeverShow(checked);
  };
  const onClose = () => {
    setIsOpen(false);
    window.localStorage.setItem('isNeverOpenGeorgiaModal', isNeverShow);
  };

  useEffect(() => {
    const isNeverOpenGeorgiaModal = window.localStorage.getItem('isNeverOpenGeorgiaModal');

    setIsOpen(!JSON.parse(isNeverOpenGeorgiaModal));
  }, []);

  const imageUrl = useMemo(() => {
    if (currentMoment.isBefore(firstStartMoment)) return 'CS/Ｗ15_drink_popup-03.png';
    if (currentMoment.isBetween(firstStartMoment, firstEndMoment)) return 'CS/Ｗ15_drink_popup-01.png';
    if (currentMoment.isBetween(secondStartMoment, secondEndMoment)) return 'CS/Ｗ15_drink_popup-02.png';
    return undefined;
  }, [currentMoment, firstStartMoment, firstEndMoment, secondStartMoment, secondEndMoment]);

  return isUndefined(imageUrl) || disablePop ? <></> : (
    <CampaignModal
      imageUrl={imageUrl}
      isNeverShow={isNeverShow}
      isOpen={isOpen}
      onCheckboxChange={onCheckboxChange}
      onClose={onClose}
    />
  );
};
